import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { Roles } from '../auth/constants/AuthConstants';
import { ReportTypes } from './interface';
import {
  isExternalAgentAllocationReportVisible,
  isFeedbackReportVisible,
  isPaymentReportVisible,
  isUnifiedCaseLevelReportVisible
} from './utils';

export enum ReportType {
  UNIFIED_CASE_LEVEL_REPORT = 'UNIFIED_CASE_LEVEL_REPORT',
  INTERACTION_VIEW_FIELD = 'INTERACTION_VIEW_FIELD',
  PAYMENT_REPORT_FIELD = 'PAYMENT_REPORT_FIELD',
  EXTERNAL_AGENT_ALLOCATION_REPORT = 'EXTERNAL_AGENT_ALLOCATION_REPORT'
}

export enum ReportStatusEnum {
  EMAIL_SENT = 'Email Sent',
  SOURCE_FAILED_SYNTAX_ERROR = 'SOURCE_FAILED_SYNTAX_ERROR',
  SOURCE_FAILED = 'SOURCE_FAILED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'In Progress'
}

export const VIEW_DEFINITION_URL =
  'https://docs.google.com/spreadsheets/d/1Q2FOiXDwGhXpv7ecyT6IKf0Oq_MMrxDa6utkGJ91y2c/edit?gid=409499292#gid=409499292';

export const ReportStatusDisplayNames: Record<ReportStatusEnum, string> = {
  [ReportStatusEnum.EMAIL_SENT]: 'Email Sent',
  [ReportStatusEnum.SOURCE_FAILED_SYNTAX_ERROR]: 'Source Failed Syntax Error',
  [ReportStatusEnum.SOURCE_FAILED]: 'Source Failed',
  [ReportStatusEnum.FAILED]: 'Failed',
  [ReportStatusEnum.IN_PROGRESS]: 'In Progress'
};

export const allowedRolesSetForViewReportStatus = new Set([
  Roles.ROLE_NAVI_FIELD_EXTERNAL_TEAM_LEAD,
  Roles.ROLE_NAVI_FIELD_TEAM_LEAD,
  Roles.ROLE_NAVI_TELE_INHOUSE_TEAM_LEAD,
  Roles.ROLE_NAVI_30_PLUS_CALLING_TEAM_LEAD,
  Roles.ROLE_NAVI_16_30_FIELD_TEAM_LEAD,
  Roles.ROLE_NAVI_16_30_FIELD_AGENCY_MANAGER,
  Roles.ROLE_NAVI_FIELD_AGENCY_TEAM_LEAD
]);

export const allowedRolesSetForConfigure = new Set([Roles.ROLE_NAVI_REPORTS_CONFIGURATION]);

export const REPORTS: ReportTypes[] = [
  {
    id: 'unified-case-level',
    title: 'DM Case Report',
    type: ReportType.UNIFIED_CASE_LEVEL_REPORT,
    description: 'Unified case level report',
    isVisible: isUnifiedCaseLevelReportVisible,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_Reports_UnifiedCaseLevelReport_DownloadClick
  },
  {
    id: 'feedback',
    title: 'Feedback level report',
    type: ReportType.INTERACTION_VIEW_FIELD,
    description: 'Feedback level report for field',
    isVisible: isFeedbackReportVisible,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_Reports_Feedback_DownloadClick
  },
  {
    id: 'payment',
    title: 'Payment report',
    type: ReportType.PAYMENT_REPORT_FIELD,
    description: 'Payment report for field',
    isVisible: isPaymentReportVisible,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_Reports_Payment_DownloadClick
  },
  {
    id: 'external-agent-allocation-report',
    title: 'External Agent Allocation Report',
    type: ReportType.EXTERNAL_AGENT_ALLOCATION_REPORT,
    description: 'External agent allocation report',
    isVisible: isExternalAgentAllocationReportVisible,
    clickStreamEvent: CLICKSTREAM_EVENT_NAMES.LH_Reports_ExternalAgentAllocationReport_DownloadClick
  }
];

export const REPORT_TYPES = {
  LAN_VIEW_FIELD: 'LAN_VIEW_FIELD',
  INTERACTION_VIEW_FIELD: 'INTERACTION_VIEW_FIELD',
  LAN_VIEW_TELE: 'LAN_VIEW_TELE',
  INTERACTION_VIEW_TELE: 'INTERACTION_VIEW_TELE',
  AGENT_VIEW_TELE: 'AGENT_VIEW_TELE',
  PAYMENT_REPORT_FIELD: 'PAYMENT_REPORT_FIELD',
  ADDRESS_VIEW_FIELD: 'ADDRESS_VIEW_FIELD',
  AGENCY_CASE_LEVEL_VIEW: 'AGENCY_CASE_LEVEL_VIEW',
  UNIFIED_CASE_LEVEL_REPORT: 'UNIFIED_CASE_LEVEL_REPORT',
  CASE_LEVEL_REPORT: 'CASE_LEVEL_REPORT',
  UNIFIED_CASE_LEVEL_REPORT_V2: 'UNIFIED_CASE_LEVEL_REPORT_V2'
};

export const REPORT_TYPE_DISPLAY_NAMES = {
  LAN_VIEW_FIELD: 'LAN View Field',
  INTERACTION_VIEW_FIELD: 'Interaction View Field',
  LAN_VIEW_TELE: 'LAN View Tele',
  INTERACTION_VIEW_TELE: 'Interaction View Tele',
  AGENT_VIEW_TELE: 'Agent View Tele',
  PAYMENT_REPORT_FIELD: 'Payment Report Field',
  ADDRESS_VIEW_FIELD: 'Address View Field',
  AGENCY_CASE_LEVEL_VIEW: 'Agency Case Level View',
  UNIFIED_CASE_LEVEL_REPORT: 'Unified Case Level Report',
  CASE_LEVEL_REPORT: 'Case Level Report',
  UNIFIED_CASE_LEVEL_REPORT_V2: 'DM Case Report',
  EXTERNAL_AGENT_ALLOCATION_REPORT: 'External Agent Allocation Report'
};

export const TEAM_TYPES = {
  TELE: 'TELE',
  ONE_TO_THIRTY_AGENCY: 'ONE_TO_THIRTY_AGENCY',
  THIRTY_PLUS_AGENCY: 'THIRTY_PLUS_AGENCY',
  EXTERNAL_AGENCY: 'EXTERNAL_AGENCY',
  INHOUSE_FIELD: 'INHOUSE_FIELD',
  DEFAULT: 'DEFAULT'
};

export const TEAM_TYPE_DISPLAY_NAMES = {
  TELE: 'Tele',
  ONE_TO_THIRTY_AGENCY: '1-30 Agency',
  THIRTY_PLUS_AGENCY: '30+ Agency',
  EXTERNAL_AGENCY: 'External Agency',
  INHOUSE_FIELD: 'Inhouse Field',
  DEFAULT: 'Default'
};
